/**
 * Fond de carte clair du portail, même source que le back-office
 * (TRIBE_backoffice_fe/src/utilities/basemap.ts).
 *
 * Style CARTO « Voyager » : terres crème, routes discrètes, le plus proche du
 * fond beige de la charte. CARTO exige une clé depuis août 2026 : sans elle,
 * les tuiles reviennent barrées d'un filigrane « API KEY REQUIRED ».
 *
 * La clé est lue dans REACT_APP_CARTO_KEY, jamais écrite en dur. Une variable
 * REACT_APP_* est résolue à la COMPILATION : elle doit être présente au
 * moment du `npm run build`. Le portail est construit par l'action Azure
 * Static Web Apps (.github/workflows) : la clé y vient du secret GitHub
 * REACT_APP_CARTO_KEY. Elle se retrouve dans le bundle servi au navigateur,
 * ce qui est inhérent à un fond de carte côté client.
 *
 * Sans clé au build, repli sur OpenStreetMap standard, clair lui aussi.
 */

const CLE_CARTO = (process.env.REACT_APP_CARTO_KEY ?? '').trim();

export const fondCartoDisponible = CLE_CARTO !== '';

if (!fondCartoDisponible && process.env.NODE_ENV !== 'test') {
  // eslint-disable-next-line no-console
  console.warn('[carte] REACT_APP_CARTO_KEY absente au build : repli sur OpenStreetMap.');
}

/** Modèle d'URL pour Leaflet, qui substitue lui-même {s} et {r}. */
export const modeleTuiles = (): string =>
  fondCartoDisponible
    ? `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${encodeURIComponent(CLE_CARTO)}`
    : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

/** Sous-domaines à déclarer à Leaflet (CARTO en publie quatre, OSM trois). */
export const sousDomaines = (): string => (fondCartoDisponible ? 'abcd' : 'abc');

/** Attribution exigée : CARTO et OpenStreetMap. Texte fixe, sans donnée serveur. */
export const attributionFond = fondCartoDisponible
  ? '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
  : '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
